import { RouteComponent } from "react-router";
import { RouteFragment, RouteHelper, UrlHelper } from "../Imports";

export class RootRoute extends RouteFragment {
    constructor(component: RouteComponent, indexComponent?: RouteComponent | string) {
        super(component, indexComponent);
    }

    public getRoute(): string {
        return RouteHelper.toLowerCaseExceptParameters(UrlHelper.getRootRouteUrlWithoutSlash());
    }

    protected formatUrl(): string {
        return this.getRoute();
    }
}
